import { STRINGS } from 'config';
import { getFeatureFlags } from 'store/action/featureFlags';
import { setPracticeCookie } from 'utils/cookies';

const { SET_PRACTICE } = STRINGS.REDUCERS.APP;

export const setPractice = (dispatch, practice, isEhub) => {
  dispatch({ type: SET_PRACTICE, payload: { practice, isEhub } });
  setPracticeCookie(practice.id);
  getFeatureFlags(practice.id)(dispatch);
};
